import { c as _c } from "react/compiler-runtime";
import { isAddressEqual } from "@opensea/utils";
import { uniqBy } from "es-toolkit/array";
import { keyBy } from "es-toolkit/compat";
import { useSnapshot } from "valtio";
import { usePreviouslyConnectedAccounts } from "../../../../../polychain/hooks";
import { CustomDestinationWalletsState } from "../../../../../stores/customDestinationWalletsStore";
export function useDestinationWallets() {
  const $ = _c(6);
  const {
    destinationWallets,
    lastSelectedWallet
  } = useSnapshot(CustomDestinationWalletsState);
  const previouslyConnectedAccounts = usePreviouslyConnectedAccounts();
  let uniqueWallets;
  if ($[0] !== destinationWallets || $[1] !== lastSelectedWallet || $[2] !== previouslyConnectedAccounts) {
    const previouslyConnectedAccountsByAddress = keyBy(previouslyConnectedAccounts, _temp);
    const wallets = destinationWallets.map(wallet => {
      const previouslyConnectedAccount = previouslyConnectedAccountsByAddress[wallet.address.toLowerCase()];
      return {
        ...wallet,
        connectorId: previouslyConnectedAccount?.connectorId
      };
    }).concat(previouslyConnectedAccounts.map(_temp2));
    uniqueWallets = uniqBy(wallets, _temp3);
    if (lastSelectedWallet) {
      let t0;
      if ($[4] !== lastSelectedWallet) {
        t0 = wallet_1 => isAddressEqual(wallet_1.address, lastSelectedWallet.address);
        $[4] = lastSelectedWallet;
        $[5] = t0;
      } else {
        t0 = $[5];
      }
      const lastSelectedIndex = uniqueWallets.findIndex(t0);
      if (lastSelectedIndex > 0) {
        const lastSelected = uniqueWallets.splice(lastSelectedIndex, 1)[0];
        uniqueWallets.unshift(lastSelected);
      }
    }
    $[0] = destinationWallets;
    $[1] = lastSelectedWallet;
    $[2] = previouslyConnectedAccounts;
    $[3] = uniqueWallets;
  } else {
    uniqueWallets = $[3];
  }
  return uniqueWallets;
}
function _temp3(wallet_0) {
  return wallet_0.address.toLowerCase();
}
function _temp2(account_0) {
  return {
    identifier: account_0.address,
    address: account_0.address,
    connectorId: account_0.connectorId
  };
}
function _temp(account) {
  return account.address.toLowerCase();
}
export const useGetDestinationWallet = () => {
  const $ = _c(2);
  const destinationWallets = useDestinationWallets();
  let t0;
  if ($[0] !== destinationWallets) {
    t0 = address => destinationWallets.find(wallet => isAddressEqual(wallet.address, address));
    $[0] = destinationWallets;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};